'use client'
import useMount from "react-use/lib/useMount";
import { useEffect } from "react";
import styles from './singleProperty.module.css';
import wrappers from 'components/_styled/wrappers.module.css';
import { testimonials, TestimonialType } from "./data";
import SinglePropertyForm from "./SinglePropertyForm";
import { useDispatch } from "react-redux";
import { openModalAction } from "_slices/modal";
import { ReducerProvider } from "./SinglePropertyForm/reducer";
import ListSingleUnitBox from "./ListSingleUnitBox";
import { useRouter, useSearchParams } from 'next/navigation';
import Link from "next/link";
import logPageView from "lib/ga/pageView";
import API from "@/utils/API";

const SinglePropertyPage = () => {
  const reduxDispatch = useDispatch();
  const router = useRouter();

  const queryParams = useSearchParams();

  useMount(() => {
    logPageView({ url: window.location.pathname + window.location.search });
  });

  const payment = queryParams?.get('payment')
  const unitname = queryParams?.get('unitname') ?? ''

  useEffect(() => {
    if (payment) {
      if (payment === 'success') {
        // Send the email confirmation - not ideal as a page refresh will cause it to be sent again
        API.singleProperty.confirmation({ unitname })
        .then(() => {
          // Replace the url with a vanilla one so we don't get multiple confirmations on page reload
          router.replace('/sales/single-property')
        })
        .catch(err => {
          console.error('API.singleProperty.confirmation error', err)
        })
      } else {
        router.replace('/sales/single-property')
      }
  
      reduxDispatch(
        openModalAction({
          componentName: "GeneralSuccessMessage",
          componentProps: {
            title: payment === "success" ? 'Payment was completed successfully' : 'Payment was not completed successfully',
            success: payment === "success"
          },
        })
      );
    }
  }, [payment]);


  return <div className={`${wrappers.FluidWrapper} ${styles.SalesWrapper}`} >
      <div className={styles.SinglePropertyWrapper}>
        <ListSingleUnitBox button={false} />
        <div className={styles.MainContentBox}>
          <div className={styles.SideBar}>
            <h2>The next steps to list your property...</h2>
            <ul>
              <li>
                <div>1</div><span>Create a free Completely Retail <a href="/sales/single-property?modal=auth-register">account</a> or <a href="/sales/single-property?modal=auth-login">sign in</a></span>
              </li>
              <li>
                <div>2</div><span>Fill in your property details and upload a photo</span>
              </li>
              <li>
                <div>3</div><span>Choose your preferred payment method and enter your billing details to complete your order</span>
              </li>
              <li>
                <div>4</div><span>Your submission will be reviewed by our team, we'll get in touch if further details are required</span>
              </li>
              <li>
                <div>5</div><span>Our team will set your property listing live and provide a link to the page</span>
              </li>
            </ul>
            <p>
              Got a question about single property listings?
              <Link prefetch={false} href="/sales/contact" className={styles.contactButton}>
                Contact Us
              </Link>
            </p>
            <br/>
            <h2>Example listing</h2>

            <img src="/images/single-listing.jpg"/>
            
            {testimonials.length > 0 && (
              <>
                {testimonials.map((test: TestimonialType) => {
                  return (
                    <div key={test.name} className={styles.Testimonial}>
                      <div className={styles.TestimonalContentWrapper}>
                        <div className={styles.TestimonalSpeach}>
                          <img alt={test.name} src="/icons/sales/speak.svg" />
                        </div>
                        <div className={styles.ExtraContent}>"{test.content}"</div>
                        <div className={styles.TestimonalBrand}>{test.name}</div>
                      </div>
                      <div className={styles.TestimonalIconHolder}>
                        <div className={styles.TestimonalIcon}>
                          <img alt={test.name} src={test.icon} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <ReducerProvider>
            <SinglePropertyForm />
          </ReducerProvider>
        </div>
      </div>
    </div>
};

export default SinglePropertyPage;
